export default __webpack_public_path__ + "static/media/15.82dd8fa6.png";